import { render } from "./ViewTickets.vue?vue&type=template&id=326bff50&scoped=true"
import script from "./ViewTickets.vue?vue&type=script&lang=js"
export * from "./ViewTickets.vue?vue&type=script&lang=js"

import "./ViewTickets.vue?vue&type=style&index=0&id=326bff50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326bff50"],['__file',"src/views/External/ViewTickets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "326bff50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('326bff50', __exports__)) {
    api.reload('326bff50', __exports__)
  }
  
  module.hot.accept("./ViewTickets.vue?vue&type=template&id=326bff50&scoped=true", () => {
    api.rerender('326bff50', render)
  })

}


export default __exports__